import NiceModal from "@ebay/nice-modal-react";
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Typography from "@mui/material/Typography";

export const BusyModal = NiceModal.create((props) => {
  const modal = NiceModal.useModal();

  return (
    <Dialog maxWidth="xs" open={modal.visible} TransitionProps={{onExited:()=> document.body.style.overflowY='auto'}}    >
      <DialogContent>
        <div className="text-center gap-5">
          <CircularProgress variant="indeterminate" />
          <Typography>{props.message ?? "Please wait..."}</Typography>
        </div>
      </DialogContent>
    </Dialog>
  );
});

const modalId = "busy-modal";
NiceModal.register(modalId, BusyModal);

export function showBusyModal(message) {
  const props = {
    message,
  };
  NiceModal.show(modalId, props);
}

export function hideBusyModal() {
  NiceModal.hide(modalId);
}
